import { ParsedEmbed } from './types';

/**
 * Parses custom embed syntax from markdown content.
 *
 * Syntax: ::embed-type[id]{param1=value1 param2=value2}
 *
 * Examples:
 *   ::pipelinetemplates[550e8400-e29b-41d4-a716-446655440000]
 *   ::pipelinetemplates[traffic]
 *   ::deploybutton[]
 *
 * The syntax follows the generic directive syntax used by remark-directive,
 * making it familiar to those who work with markdown extensions.
 */
const EMBED_REGEX = /::([a-z-]+)\[([^\]]*)\](?:\{([^}]*)\})?/g;

function parseParams(paramsString: string | undefined): Record<string, string> {
  if (!paramsString) return {};

  const params: Record<string, string> = {};
  const paramPairs = paramsString.split(/\s+/);

  for (const pair of paramPairs) {
    const [key, value] = pair.split('=');
    if (key) {
      params[key.trim()] = value?.trim() ?? 'true';
    }
  }

  return params;
}

export function parseEmbeds(content: string): ParsedEmbed[] {
  const embeds: ParsedEmbed[] = [];
  let match;

  while ((match = EMBED_REGEX.exec(content)) !== null) {
    embeds.push({
      type: match[1],
      id: match[2],
      params: parseParams(match[3]),
      fullMatch: match[0],
    });
  }

  return embeds;
}

export function hasEmbeds(content: string): boolean {
  return EMBED_REGEX.test(content);
}
